import RestResourceService from "@/services/RestResourceService";


function initialState() {
    return {
        documents: [],
        paging: [],
        totalResult: '',
        pageCount: null,
    }
}

export default {
    state: initialState(),
    getters: {
        ITEMS_DOCUMENTS: state => {
            return state.documents
        },
        ITEMS_DOCUMENTS_TOTAL_RESULT: state => {
            return state.totalResult
        },
        ITEMS_DOCUMENTS_PAGING: state => {
            return state.paging;
        },
        ITEMS_DOCUMENTS_PAGE_COUNT: state => {
            return state.pageCount;
        },
    },
    mutations: {
        SET_ITEMS_DOCUMENTS(state, payload) {
            state.documents = payload;
        },
        SET_ITEMS_TOTAL_RESULT(state, payload) {
            state.totalResult = payload;
        },
        SET_ITEMS_PAGING(state, payload) {
            state.paging = payload;
        },
        SET_ITEMS_DOCUMENTS_PAGE_COUNT(state, payload) {
            state.pageCount = payload;
        },
        SET_ITEM(state, payload) {
            state.item = payload;
        },
        REMOVE_DOCUMENTS_ITEM(state, id) {
            state.documents = state.documents.filter(item => item.document.id !== id);
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
    },
    actions: {
        POST_ITEMS_DOCUMENTS_WITH_SEARCH_QUERY: async ({commit}, payload) => {
            return RestResourceService.postResources(`api/v1/search/hornbach-de/search`, payload.searchQuery)
                .then((response) => {
                    commit('SET_ITEMS_DOCUMENTS', response.data.result.search.documents);
                    commit('SET_ITEMS_TOTAL_RESULT', response.data.result.search.total);
                    commit('SET_ITEMS_PAGING', response.data.result.search.paging);
                    commit('SET_ITEMS_DOCUMENTS_PAGE_COUNT', response.data.result.search.paging.pageCount);
                })
                .catch((error) => {
                    throw new Error(error);
                })
        },
        RESET: (context, payload) => {
            context.commit('RESET', payload);
        },
    }
}
